// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const LoginSection = styled.div`
`;

const LoginSectionComponent = ({ children }) => {
    return <LoginSection>{children}</LoginSection>;
};

export default LoginSectionComponent;
